import { Modal } from "antd";
import type { StockNoteItem } from "./UserStockNoteType";
import type { FC } from "react";
import "./StockNoteImportPicker.css";

const RECT_BTN = "user-holding-rect-btn";

export interface StockNoteImportPickerProps {
  open: boolean;
  stockCode: string;
  stockName?: string;
  notes: StockNoteItem[];
  loading?: boolean;
  onClose: () => void;
  onPick: (note: StockNoteItem) => void;
  onGoWriteNote: () => void;
}

const StockNoteImportPicker: FC<StockNoteImportPickerProps> = ({
  open,
  stockCode,
  stockName,
  notes,
  loading = false,
  onClose,
  onPick,
  onGoWriteNote,
}) => {
  const title = stockName?.trim()
    ? `从笔记导入 · ${stockName}（${stockCode}）`
    : `从笔记导入 · ${stockCode}`;

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onClose}
      footer={null}
      width={520}
      destroyOnClose
      className="stock-note-import-picker"
    >
      {loading ? (
        <p className="stock-note-import-picker__muted">加载中…</p>
      ) : notes.length === 0 ? (
        <div className="stock-note-import-picker__empty">
          <p className="stock-note-import-picker__muted">暂无笔记</p>
          <button type="button" className="stock-note-import-picker__link" onClick={onGoWriteNote}>
            去写笔记
          </button>
        </div>
      ) : (
        <ul className="stock-note-import-picker__list">
          {notes.map((n) => (
            <li key={n.id}>
              <button
                type="button"
                className="stock-note-import-picker__row"
                onClick={() => {
                  onPick(n);
                  onClose();
                }}
              >
                <span className="stock-note-import-picker__meta">
                  <span>{n.eventTime.slice(0, 16)}</span>
                  <span className={`stock-note-import-picker__tag stock-note-import-picker__tag--${n.category}`}>
                    {n.category}
                  </span>
                </span>
                <span className="stock-note-import-picker__content">{n.content}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
};

export default StockNoteImportPicker;
